

const urlParams = {
    protocol:'https',
    ip:'server.alliames.app.br',
}

export default urlParams;








